import React from 'react';
import { useTranslation } from 'react-i18next';

import styled from 'styled-components';
import { Typography } from '@dev/ee-components';
import { CampaignType } from '@dev/ee-api/ee-api-models';
import { convertToLocalTime } from '@dev/ee-tools';

const DescribeWrapper = styled.div`
    margin-top: 32px;
    text-align: center;
`;

export const Description = (props: {
    campaignType: CampaignType;
    isScheduled: boolean;
    sendTime: string;
    isTimingOptions: boolean;
}): JSX.Element => {
    const { t } = useTranslation();
    const { campaignType, sendTime, isScheduled, isTimingOptions } = props;
    const scheduledDesc = (
        <>
            {t('scheduledcampaignfor')} <b>{convertToLocalTime(sendTime, 'LLL')}</b>
        </>
    );
    let text;

    switch (campaignType) {
        case CampaignType.SendNow:
            if (isScheduled) {
                text = scheduledDesc;
            } else if (isTimingOptions) {
                text = t('sendcampaignsuccess_settimingOpt_desc');
            } else {
                text = t('sendcampaignsuccess_desc');
            }
            break;
        case CampaignType.Automated:
            text = t('activatedautoresponder');
            break;
        case CampaignType.AbSplit:
            if (isScheduled) {
                text = scheduledDesc;
            } else {
                text = t('sendabsuccess_desc');
            }
            break;
        default:
            break;
    }

    return (
        <DescribeWrapper>
            <Typography variant="body1">{text}</Typography>
        </DescribeWrapper>
    );
};
